<template>
  <Loading v-if="campaignIsLoadingSetlistCreate" />
  <div
    class="h-full min-h-screen md:min-h-0 flex flex-col bg-black playlist-sort"
    v-else
  >
    <header class="relative px-5 py-10 flex items-start">
      <NavMenu :isDark="true" />

      <router-link
        class="w-15 h-15 cursor-pointer flex justify-center items-center"
        to="/search-tracks"
      >
        <Icon id="arrowLeft" />
      </router-link>
      <h1 class="text-base text-white text-center w-full mr-4">
        {{ $t("playlistSortTitle") }}
      </h1>
    </header>
    <div class="flex-1 px-4 pb-56 md:overflow-y-scroll">
      <draggable
        v-model="trackIdsSelected"
        class="drag-group"
        group="cards"
        ghost-class="ghost"
        handle=".music-item-icon"
      >
        <div v-for="(track, index) in tracks" :key="index">
          <MusicCard
            :title="track.name"
            :subtitle="track.artist_name"
            :images="track.images"
            :numberSelection="index + 1"
            icon="dragIcon"
            :class="{ hidden: getIstTrackHidden(index) }"
          />
        </div>
      </draggable>
    </div>
    <div class="px-10 py-12 fixed bg-black left-0 md:absolute bottom-0 w-full">
      <Button :title="$t('playlistSortButton')" @click.native="generatePlaylist" />
    </div>
  </div>
</template>

<script lang="ts">
import { RouteGuardHandler } from '@/mixins/route-guard-handler'
import { TranslationHandler } from '@/mixins/translation-handler'
import { RestTrack } from '@/types'
import { Component, Mixins } from 'vue-property-decorator'
import draggable from 'vuedraggable'
import { Action, Getter } from 'vuex-class'
import Loading from '@/app/components/Loading.vue'

@Component({
  components: {
    draggable,
    Loading,
  },
})
export default class PlaylistSort extends Mixins(TranslationHandler, RouteGuardHandler) {
  @Getter campaignTracks!: RestTrack[]
  @Getter campaignIsSetlist!: boolean
  @Getter campaignIsLoadingSetlistCreate!: boolean
  @Action('CAMPAIGN_CREATE_SETLIST') campaignCreateSetlist!: () => Promise<void>
  @Action('GO_TO_NEXT_STEP') goToNextStep!: () => void

  created () {
    this.$routeGuardPlaylistFavorite()
  }

  get trackMap (): { [id: number]: RestTrack } {
    return Object.fromEntries(this.campaignTracks.map((t) => [t.id, t]))
  }

  get trackIdsSelected (): number[] {
    return this.$store.getters.campaignTrackIdsSelected
  }

  set trackIdsSelected (data: number[]) {
    this.$store.commit('SET_CAMPAIGN_TRACK_IDS_SELECTED', data)
  }

  get tracks (): RestTrack[] {
    return this.trackIdsSelected
      .map(selectedId => this.trackMap[selectedId])
      .filter((item) => !!item)
  }

  // hidden is better then filter for the draggble plugin
  getIstTrackHidden (index: number): boolean {
    if (this.campaignIsSetlist) {
      return [
        0,
        this.trackIdsSelected.length - 2,
        this.trackIdsSelected.length - 1,
      ].includes(index)
    }
    return false
  }

  async generatePlaylist () {
    await this.campaignCreateSetlist()
    this.goToNextStep()
  }
}
</script>

<style scoped lang="scss">
.ghost {
  opacity: 1;
  border-radius: 5px;
}
</style>
